class ExtendSectionS1LP4 extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSections1lp4] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };

    _safeInit(() => this.initHero());
    _safeInit(() => this.carryParams());
    _safeInit(() => this.initS1lp4Reveal());
    _safeInit(() => this.initS1lp4Demo());
    _safeInit(() => this.initS1lp4Natural());
    _safeInit(() => this.initS1lp4Editing());
    _safeInit(() => this.initS1lp4Cases());
    _safeInit(() => this.initS1lp4Faq());
    _safeInit(() => this.initS1lp4Purchase());
    _safeInit(() => this.initStickyBarDefault());
    _safeInit(() => this.initS1LP4TitleHero());
    _safeInit(() => this.initS1lp4CompareTitle());
    _safeInit(() => this.initS1lp4TechTitle());
    _safeInit(() => this.initS1lp4CreatorsTitle());

    this._scrollEffects = [_safeInit(() => this.initHeader()), _safeInit(() => this.initStickyScroll())].filter(Boolean);
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  onScroll() {
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  carryParams() {
    var currentParams = new URLSearchParams(window.location.search);
    var productLinks = document.querySelectorAll("a[data-carry-url-params]");

    for (var i = 0; i < productLinks.length; i++) {
      var link = productLinks[i];

      if (link.hasAttribute("data-carry-url-params-bound")) {
        continue;
      }

      var lpVersion = link.getAttribute("data-lp-version");
      var productUrl;

      try {
        productUrl = new URL(link.href, window.location.href);
      } catch (error) {
        continue;
      }

      if (productUrl.origin !== window.location.origin || productUrl.pathname.indexOf("/products/") !== 0) {
        continue;
      }

      currentParams.forEach(function (value, key) {
        if (key === "lp_version" || !productUrl.searchParams.has(key)) {
          productUrl.searchParams.set(key, value);
        }
      });

      if (lpVersion) {
        productUrl.searchParams.set("lp_version", lpVersion);
      }

      link.href = productUrl.pathname + productUrl.search + productUrl.hash;
      link.setAttribute("data-carry-url-params-bound", "true");
    }
  }

  initS1lp4Reveal() {
    const elements = Array.from(document.querySelectorAll(".extend-s1lp4 .extend-s1lp4__reveal:not(.in)"));

    if (this._s1lp4RevealObserver) {
      this._s1lp4RevealObserver.disconnect();
      this._s1lp4RevealObserver = null;
    }

    if (!elements.length) return;

    if (!("IntersectionObserver" in window)) {
      elements.forEach((element) => element.classList.add("in"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add("in");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    this._s1lp4RevealObserver = observer;
    elements.forEach((element) => observer.observe(element));
  }

  initStickyScroll() {
    // 重新初始化前清理旧监听。
    if (this._stickyScrollCleanup) {
      this._stickyScrollCleanup();
    }

    const stickyBar = this._q("#es1lp2-mobileBuy");
    const hero = this._q(".extend-s1lp4-hero");
    if (!stickyBar || !hero) return null;

    let frame = 0;

    const update = () => {
      const heroBottom = hero.getBoundingClientRect().bottom;

      stickyBar.classList.toggle("is-visible", heroBottom <= 120);
    };

    const onScroll = () => {
      if (frame) return;

      frame = requestAnimationFrame(() => {
        frame = 0;
        update();
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    this._stickyScrollCleanup = () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      cancelAnimationFrame(frame);
      delete this._stickyScrollCleanup;
    };

    update();

    // 与你原来的方法一致，返回更新函数。
    return update;
  }

  initStickyBarDefault() {
    const stickyBar = this._q("#es1lp2-mobileBuy");
    if (!stickyBar) return;

    const stickyPackName = this._q(".es1lp2b__stickyPack", stickyBar);
    const stickyPackPrice = this._q(".es1lp2b__stickyPrice", stickyBar);

    // 【核心】：自动寻找页面上当前带有 active 的套餐卡片
    const activeCard = this._q(".es1lp1p__pack-card.active");

    // 如果找到了激活的卡片，就读取它的 data 属性并更新悬浮栏
    if (activeCard) {
      const name = activeCard.dataset.packName;
      const price = activeCard.dataset.packPrice;

      if (stickyPackName && name) stickyPackName.textContent = name;
      if (stickyPackPrice && price) stickyPackPrice.textContent = price;
    }
  }

  initHeader() {
    const headerEl = this._q(".extend-s1lp4-header");
    if (!headerEl) return;
    const rail = this._q(".es1lp4pg__bar", headerEl);
    return () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      rail.style.width = (max ? (scrollTop / max) * 100 : 0) + "%";
      console.log(scrollTop);
      headerEl.classList.toggle("is-sticky", scrollTop > 46);
    };
  }

  initHero() {
    const headerEl = this._q(".extend-s1lp4-hero");
    if (!headerEl) return null;

    if (typeof headerEl._heroCleanup === "function") {
      headerEl._heroCleanup();
    }

    const q = (selector) => headerEl.querySelector(selector);
    const qa = (selector) => Array.from(headerEl.querySelectorAll(selector));

    const compareRange = q("#heroCompareRange");
    const clearLayer = q("#heroClearLayer");
    const compareHandle = q("#heroCompareHandle");
    const noiseField = q("#heroNoiseField");

    const sceneButtons = qa("[data-scene]");
    const modeButtons = qa("[data-hero-mode]");

    const sceneCount = q("#heroSceneCount");
    const sceneChallenge = q("#heroSceneChallenge");
    const sceneTitle = q("#heroSceneTitle");
    const sceneBody = q("#heroSceneBody");

    const fallback = q("#heroFallback");
    const imageWrap = q(".es1lp4hr__scene-image");

    const rawAudio = q("#heroRawAudio");
    const clearAudio = q("#heroClearAudio");
    const playButton = q("#heroPlay");
    const progress = q("#heroProgress");

    if (
      !compareRange ||
      !sceneButtons.length ||
      !sceneCount ||
      !sceneChallenge ||
      !sceneTitle ||
      !sceneBody ||
      !rawAudio ||
      !clearAudio ||
      !playButton ||
      !progress
    ) {
      return null;
    }

    const playIcon = playButton.querySelector(".es1lp4hr__play-icon");
    if (!playIcon) return null;

    const removers = [];
    const sceneStyles = ["street", "cafe", "car", "outdoor"];

    let currentMode = "raw";
    let switchVersion = 0;
    let destroyed = false;
    let pendingMetadata = null;
    let progressFrame = 0;

    const listen = (element, event, handler) => {
      element.addEventListener(event, handler);
      removers.push(() => element.removeEventListener(event, handler));
    };

    const activeAudio = () => {
      return currentMode === "raw" ? rawAudio : clearAudio;
    };

    const clearMetadataListener = () => {
      if (!pendingMetadata) return;

      pendingMetadata.audio.removeEventListener("loadedmetadata", pendingMetadata.handler);

      pendingMetadata = null;
    };

    const updateProgress = () => {
      const audio = activeAudio();

      const percent = Number.isFinite(audio.duration) && audio.duration > 0 ? (audio.currentTime / audio.duration) * 100 : 0;

      progress.style.width = Math.min(100, Math.max(0, percent)) + "%";
    };

    const stopProgressLoop = () => {
      cancelAnimationFrame(progressFrame);
      progressFrame = 0;
    };

    const startProgressLoop = () => {
      stopProgressLoop();

      const tick = () => {
        progressFrame = 0;
        if (destroyed) return;

        updateProgress();

        const audio = activeAudio();

        if (!audio.paused && !audio.ended) {
          progressFrame = requestAnimationFrame(tick);
        }
      };

      progressFrame = requestAnimationFrame(tick);
    };

    const setPlayingState = (playing) => {
      playButton.dataset.playing = String(playing);
      playIcon.textContent = playing ? "Ⅱ" : "▶";

      if (playing && !destroyed) {
        startProgressLoop();
      } else {
        stopProgressLoop();
        updateProgress();
      }
    };

    const stopAudio = (reset) => {
      rawAudio.pause();
      clearAudio.pause();

      if (reset) {
        [rawAudio, clearAudio].forEach((audio) => {
          try {
            audio.currentTime = 0;
          } catch (error) {
            // 未加载媒体时，后续加载会从头开始。
          }
        });
      }

      setPlayingState(false);

      if (reset) {
        progress.style.width = "0%";
      }
    };

    const updatePlayButton = () => {
      playButton.disabled = !activeAudio().getAttribute("src");
    };

    const setText = (element, value) => {
      const text = value || "";

      element.textContent = text;
      element.hidden = !text.trim();
    };

    const setHeroCompare = (value) => {
      const min = Number(compareRange.min) || 8;
      const max = Number(compareRange.max) || 92;
      const number = Number(value);

      const position = Math.min(max, Math.max(min, Number.isFinite(number) ? number : 52));

      if (clearLayer) {
        clearLayer.style.clipPath = `inset(0 0 0 ${position}%)`;
      }

      if (compareHandle) {
        compareHandle.style.left = `${position}%`;
      }

      if (noiseField) {
        noiseField.style.opacity = Math.max(0.18, position / 100).toFixed(2);
      }
    };

    const updateSceneImage = (button) => {
      if (!imageWrap) return;

      const url = (button.dataset.image || "").trim();

      imageWrap.removeAttribute("hidden");
      imageWrap.style.removeProperty("display");

      // 当前场景无图片，不保留空 img。
      if (!url) {
        imageWrap.replaceChildren();
        return;
      }

      let image = imageWrap.querySelector("img");

      if (!image) {
        image = document.createElement("img");
        image.id = "heroSceneImage";
        image.loading = "lazy";
        imageWrap.appendChild(image);
      }

      image.alt = button.dataset.imageAlt || "";
      image.sizes = "100vw";

      [
        ["width", button.dataset.imageWidth],
        ["height", button.dataset.imageHeight],
        ["srcset", button.dataset.imageSrcset]
      ].forEach(([attribute, value]) => {
        if (value) {
          image.setAttribute(attribute, value);
        } else {
          image.removeAttribute(attribute);
        }
      });

      image.src = url;
    };

    const setScene = (button) => {
      if (!button || destroyed) return;

      switchVersion += 1;
      clearMetadataListener();
      stopAudio(true);

      setText(sceneCount, button.dataset.count);
      setText(sceneChallenge, button.dataset.challenge);
      setText(sceneTitle, button.dataset.title);
      setText(sceneBody, button.dataset.body);

      if (fallback) {
        sceneStyles.forEach((style) => {
          fallback.classList.remove(style);
        });

        fallback.classList.add(sceneStyles.includes(button.dataset.sceneKey) ? button.dataset.sceneKey : "cafe");
      }

      updateSceneImage(button);

      sceneButtons.forEach((sceneButton) => {
        const selected = sceneButton === button;

        sceneButton.classList.toggle("active", selected);
        sceneButton.setAttribute("aria-selected", String(selected));
      });

      [
        [rawAudio, button.dataset.rawAudio],
        [clearAudio, button.dataset.clearAudio]
      ].forEach(([audio, url]) => {
        if (url) {
          audio.src = url;
        } else {
          audio.removeAttribute("src");
        }

        audio.load();
      });

      updatePlayButton();
    };

    const playAudio = (audio, version) => {
      audio
        .play()
        .then(() => {
          if (destroyed || audio !== activeAudio()) {
            audio.pause();
            return;
          }

          // 旧请求不修改新的播放状态。
          if (version !== switchVersion) return;

          setPlayingState(true);
        })
        .catch(() => {
          if (!destroyed && version === switchVersion) {
            setPlayingState(false);
          }
        });
    };

    const setMode = (mode) => {
      if (destroyed || (mode !== "raw" && mode !== "clear") || mode === currentMode) {
        return;
      }

      const previousAudio = activeAudio();
      const wasPlaying = !previousAudio.paused && !previousAudio.ended;
      const previousTime = previousAudio.currentTime || 0;
      const version = ++switchVersion;

      clearMetadataListener();
      stopAudio(false);
      currentMode = mode;

      modeButtons.forEach((button) => {
        const selected = button.dataset.heroMode === mode;

        button.classList.toggle("active", selected);
        button.setAttribute("aria-selected", String(selected));
      });

      const nextAudio = activeAudio();
      updatePlayButton();

      if (!nextAudio.getAttribute("src")) {
        progress.style.width = "0%";
        return;
      }

      const continueAtSameTime = () => {
        if (destroyed || version !== switchVersion) return;

        clearMetadataListener();

        if (Number.isFinite(nextAudio.duration)) {
          try {
            nextAudio.currentTime = Math.min(previousTime, Math.max(0, nextAudio.duration - 0.1));
          } catch (error) {
            // 不可定位的媒体保留当前播放位置。
          }
        }

        updateProgress();

        if (wasPlaying) {
          playAudio(nextAudio, version);
        }
      };

      if (nextAudio.readyState >= 1) {
        continueAtSameTime();
      } else {
        pendingMetadata = {
          audio: nextAudio,
          handler: continueAtSameTime
        };

        nextAudio.addEventListener("loadedmetadata", continueAtSameTime);

        nextAudio.load();
      }
    };

    listen(compareRange, "input", () => {
      setHeroCompare(compareRange.value);
    });

    sceneButtons.forEach((button) => {
      listen(button, "click", () => setScene(button));
    });

    modeButtons.forEach((button) => {
      listen(button, "click", () => {
        setMode(button.dataset.heroMode);
      });
    });

    listen(playButton, "click", () => {
      const audio = activeAudio();
      if (!audio.getAttribute("src")) return;

      clearMetadataListener();
      const version = ++switchVersion;

      if (audio.paused) {
        playAudio(audio, version);
      } else {
        stopAudio(false);
      }
    });

    [rawAudio, clearAudio].forEach((audio) => {
      // timeupdate 作为补充，播放期间主要由逐帧循环更新。
      listen(audio, "timeupdate", () => {
        if (audio === activeAudio()) updateProgress();
      });

      listen(audio, "pause", () => {
        if (!destroyed && audio === activeAudio()) {
          setPlayingState(false);
        }
      });

      listen(audio, "ended", () => {
        if (audio !== activeAudio()) return;

        switchVersion += 1;
        clearMetadataListener();
        stopAudio(true);
      });

      listen(audio, "error", () => {
        if (audio === activeAudio()) {
          setPlayingState(false);
        }
      });
    });

    headerEl._heroCleanup = () => {
      destroyed = true;
      switchVersion += 1;

      clearMetadataListener();
      stopProgressLoop();
      removers.forEach((remove) => remove());
      stopAudio(false);

      delete headerEl._heroCleanup;
    };

    // 初始化时统一音源按钮状态。
    modeButtons.forEach((button) => {
      const selected = button.dataset.heroMode === currentMode;

      button.classList.toggle("active", selected);
      button.setAttribute("aria-selected", String(selected));
    });

    setHeroCompare(compareRange.value);
    setScene(q(".es1lp4hr__scene-tab.active") || sceneButtons[0]);

    return headerEl;
  }

  initS1lp4Demo() {
    const sectionEl = this._q(".extend-s1lp4-demo");
    if (!sectionEl) return null;

    // 清理同一 Section 上一次初始化的事件。
    if (typeof sectionEl._es1lp4DemoCleanup === "function") {
      sectionEl._es1lp4DemoCleanup();
    }

    const q = (selector) => sectionEl.querySelector(selector);
    const qa = (selector) => Array.from(sectionEl.querySelectorAll(selector));

    const shell = q(".es1lp4d__shell");
    const sceneTabs = qa(".es1lp4d__tab[data-demo-config]");
    const modeTabs = qa("[data-demo-mode]");

    const els = {
      fallback: q("#demoFallback"),
      badge: q("#demoBadge"),
      tags: q("#ambientTags"),
      kicker: q("#demoKicker"),
      title: q("#demoTitle"),
      description: q("#demoDescription"),
      best: q("#demoBest"),
      listen: q("#demoListen"),
      wave: q("#demoWaveform"),
      waveSmall: q("#waveLabelSmall"),
      waveLabel: q("#waveLabel"),
      waveStatus: q("#waveStatus"),
      background: q("#listenBackground"),
      voice: q("#listenVoice"),
      post: q("#listenPost"),
      raw: q("#demoRawAudio"),
      clear: q("#demoClearAudio"),
      play: q("#demoPlay"),
      progress: q("#demoProgress"),
      time: q("#demoTime")
    };

    if (!shell || !sceneTabs.length || !els.raw || !els.clear || !els.play) {
      return null;
    }

    const parseConfig = (value) => {
      try {
        return JSON.parse(value || "{}");
      } catch (error) {
        console.warn("Invalid S1LP4 demo configuration.", error);
        return {};
      }
    };

    const labels = parseConfig(shell.dataset.demoLabels);
    const scenes = new Map();

    sceneTabs.forEach((tab) => {
      scenes.set(tab.dataset.demoScene, parseConfig(tab.dataset.demoConfig));
    });

    const removers = [];
    const pendingTimes = new Map();

    let currentScene = "";
    let currentMode = "raw";
    let frameId = 0;
    let playRequestId = 0;
    let destroyed = false;

    const listen = (element, eventName, handler) => {
      element.addEventListener(eventName, handler);
      removers.push(() => {
        element.removeEventListener(eventName, handler);
      });
    };

    const currentMedia = () => {
      return currentMode === "clear" ? els.clear : els.raw;
    };

    const hasSource = (media) => {
      return Boolean(media.getAttribute("src"));
    };

    const modeLabel = () => {
      return currentMode === "clear" ? labels.clear_label || "AirStudio S1" : labels.raw_label || "Ordinary Recording";
    };

    const setText = (element, value) => {
      if (!element) return;

      const text = value == null ? "" : String(value);
      element.textContent = text;
      element.hidden = text.trim() === "";
    };

    const setStatus = (value) => {
      setText(els.waveStatus, value);
    };

    const formatTime = (seconds) => {
      const value = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;

      const minutes = Math.floor(value / 60);
      const remainder = value % 60;

      return String(minutes).padStart(2, "0") + ":" + String(remainder).padStart(2, "0");
    };

    const renderProgress = () => {
      const media = currentMedia();
      const duration = Number.isFinite(media.duration) ? media.duration : 0;

      const time = Number.isFinite(media.currentTime) ? media.currentTime : 0;

      const percentage = duration > 0 ? Math.min(100, Math.max(0, (time / duration) * 100)) : 0;

      if (els.progress) {
        els.progress.style.width = percentage + "%";
      }

      if (els.time) {
        els.time.textContent = formatTime(time) + " / " + formatTime(duration);
      }
    };

    const stopFrame = () => {
      if (frameId) {
        cancelAnimationFrame(frameId);
        frameId = 0;
      }
    };

    const startFrame = () => {
      stopFrame();

      const tick = () => {
        if (destroyed) return;

        renderProgress();

        if (!currentMedia().paused) {
          frameId = requestAnimationFrame(tick);
        } else {
          frameId = 0;
        }
      };

      frameId = requestAnimationFrame(tick);
    };

    const renderPlayback = (playing) => {
      els.play.textContent = playing ? "Ⅱ" : "▶";
      els.play.dataset.playing = playing ? "true" : "false";

      els.play.setAttribute(
        "aria-label",
        playing ? labels.pause_label || "Pause matched audio" : labels.play_label || "Play matched audio"
      );

      if (els.wave) {
        els.wave.classList.toggle("playing", playing);
      }

      if (playing) {
        startFrame();
      } else {
        stopFrame();
        renderProgress();
      }
    };

    const pauseAll = () => {
      playRequestId += 1;
      els.raw.pause();
      els.clear.pause();
      renderPlayback(false);
    };

    const seekMedia = (media, seconds) => {
      const target = Number.isFinite(seconds) ? Math.max(0, seconds) : 0;

      if (media.readyState < 1) {
        pendingTimes.set(media, target);
        return;
      }

      const duration = media.duration;
      const limitedTarget = Number.isFinite(duration) ? Math.min(target, duration) : target;

      try {
        media.currentTime = limitedTarget;
        pendingTimes.delete(media);
      } catch (error) {
        pendingTimes.set(media, target);
      }
    };

    const renderAvailability = () => {
      const available = hasSource(currentMedia());

      els.play.disabled = !available;

      if (!available) {
        setStatus(labels.missing_label || "Audio not configured");
      }

      return available;
    };

    const playCurrent = () => {
      const media = currentMedia();

      if (!renderAvailability()) return;

      const requestId = ++playRequestId;
      let promise;

      try {
        promise = media.play();
      } catch (error) {
        renderPlayback(false);
        setStatus(labels.error_label || "Unable to play audio");
        return;
      }

      if (promise && typeof promise.then === "function") {
        promise
          .then(() => {
            if (destroyed || requestId !== playRequestId || media !== currentMedia()) {
              media.pause();
              return;
            }

            renderPlayback(true);
            setStatus((labels.playing_label || "Playing") + " · " + modeLabel());
          })
          .catch(() => {
            if (destroyed || requestId !== playRequestId || media !== currentMedia()) {
              return;
            }

            renderPlayback(false);
            setStatus(labels.error_label || "Unable to play audio");
          });
      }
    };

    const renderMode = () => {
      const scene = scenes.get(currentScene) || {};
      const clear = currentMode === "clear";
      const prefix = clear ? "clear_" : "raw_";

      modeTabs.forEach((tab) => {
        const active = tab.dataset.demoMode === currentMode;

        tab.classList.toggle("active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
        tab.setAttribute("tabindex", active ? "0" : "-1");

        setText(
          tab,
          tab.dataset.demoMode === "clear" ? labels.clear_label || "AirStudio S1" : labels.raw_label || "Ordinary Recording"
        );
      });

      if (els.wave) {
        els.wave.classList.toggle("raw", !clear);
      }

      setText(els.waveSmall, modeLabel());
      setText(els.waveLabel, scene[prefix + "wave_label"]);
      setText(els.background, scene[prefix + "background"]);
      setText(els.voice, scene[prefix + "voice"]);
      setText(els.post, scene[prefix + "post"]);

      const rowSettings = [
        [els.background, labels.background_label],
        [els.voice, labels.voice_label],
        [els.post, labels.post_label]
      ];

      rowSettings.forEach(([element, label]) => {
        if (!element) return;

        const row = element.closest(".es1lp4d__listen-row");
        if (!row) return;

        row.classList.toggle("active", clear);
        row.hidden = !label && element.hidden;
      });

      renderProgress();

      if (renderAvailability()) {
        setStatus(labels.ready_label || "Ready to compare");
      }
    };

    const setAudioSource = (media, url) => {
      pendingTimes.delete(media);
      media.pause();

      const source = typeof url === "string" ? url.trim() : "";

      if (source) {
        media.setAttribute("src", source);
      } else {
        media.removeAttribute("src");
      }

      media.load();
    };

    const setScene = (key) => {
      if (!scenes.has(key)) return;

      pauseAll();
      currentScene = key;

      const scene = scenes.get(key);
      const allowedStyles = ["street", "cafe", "car", "outdoor"];
      const style = allowedStyles.includes(scene.scene_style) ? scene.scene_style : "street";

      sceneTabs.forEach((tab) => {
        const active = tab.dataset.demoScene === key;

        tab.classList.toggle("active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
        tab.setAttribute("tabindex", active ? "0" : "-1");
      });

      if (els.fallback) {
        allowedStyles.forEach((name) => {
          els.fallback.classList.remove(name);
        });

        els.fallback.classList.add(style);
      }

      setText(els.badge, scene.badge);
      setText(els.kicker, scene.kicker);
      setText(els.title, scene.panel_title);
      setText(els.description, scene.panel_description);
      setText(els.best, scene.best_for);
      setText(els.listen, scene.listen_for);

      if (els.best && els.best.parentElement) {
        els.best.parentElement.hidden = !labels.best_label && els.best.hidden;
      }

      if (els.listen && els.listen.parentElement) {
        els.listen.parentElement.hidden = !labels.listen_label && els.listen.hidden;
      }

      if (els.tags) {
        els.tags.textContent = "";

        const tags = String(scene.ambient_tags || "")
          .split(/\r?\n/)
          .map((tag) => tag.trim())
          .filter(Boolean);

        tags.forEach((tag) => {
          const span = document.createElement("span");
          span.textContent = tag;
          els.tags.appendChild(span);
        });

        els.tags.hidden = tags.length === 0;
      }

      setAudioSource(els.raw, scene.raw_audio_url);
      setAudioSource(els.clear, scene.clear_audio_url);

      renderMode();
    };

    const setMode = (mode) => {
      if ((mode !== "raw" && mode !== "clear") || mode === currentMode) {
        return;
      }

      const previousMedia = currentMedia();
      const wasPlaying = !previousMedia.paused && !previousMedia.ended;
      const previousTime = previousMedia.currentTime || 0;

      pauseAll();
      currentMode = mode;

      seekMedia(currentMedia(), previousTime);
      renderMode();

      if (wasPlaying) {
        playCurrent();
      }
    };

    const bindTabKeyboard = (tabs, selectTab) => {
      tabs.forEach((tab, index) => {
        listen(tab, "keydown", (event) => {
          let nextIndex = index;

          if (event.key === "ArrowRight" || event.key === "ArrowDown") {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === "Home") {
            nextIndex = 0;
          } else if (event.key === "End") {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();

          const nextTab = tabs[nextIndex];
          nextTab.focus();
          selectTab(nextTab);
        });
      });
    };

    sceneTabs.forEach((tab) => {
      listen(tab, "click", () => {
        setScene(tab.dataset.demoScene);
      });
    });

    modeTabs.forEach((tab) => {
      listen(tab, "click", () => {
        setMode(tab.dataset.demoMode);
      });
    });

    bindTabKeyboard(sceneTabs, (tab) => {
      setScene(tab.dataset.demoScene);
    });

    bindTabKeyboard(modeTabs, (tab) => {
      setMode(tab.dataset.demoMode);
    });

    listen(els.play, "click", () => {
      const media = currentMedia();

      if (!media.paused) {
        pauseAll();
        setStatus(labels.paused_label || "Paused");
        return;
      }

      if (media.ended) {
        seekMedia(media, 0);
      }

      playCurrent();
    });

    [els.raw, els.clear].forEach((media) => {
      listen(media, "loadedmetadata", () => {
        if (pendingTimes.has(media)) {
          seekMedia(media, pendingTimes.get(media));
        }

        if (media === currentMedia()) {
          renderProgress();
        }
      });

      listen(media, "durationchange", () => {
        if (media === currentMedia()) {
          renderProgress();
        }
      });

      listen(media, "timeupdate", () => {
        if (media === currentMedia()) {
          renderProgress();
        }
      });

      listen(media, "play", () => {
        if (media !== currentMedia() || destroyed) {
          media.pause();
          return;
        }

        renderPlayback(true);
        setStatus((labels.playing_label || "Playing") + " · " + modeLabel());
      });

      listen(media, "pause", () => {
        if (media !== currentMedia() || destroyed) return;

        renderPlayback(false);

        if (!media.ended && hasSource(media)) {
          setStatus(labels.paused_label || "Paused");
        }
      });

      listen(media, "ended", () => {
        if (media !== currentMedia() || destroyed) return;

        playRequestId += 1;

        els.raw.pause();
        els.clear.pause();

        seekMedia(els.raw, 0);
        seekMedia(els.clear, 0);

        renderPlayback(false);
        renderProgress();

        setStatus(labels.ready_label || "Ready to compare");
      });

      listen(media, "error", () => {
        if (media !== currentMedia() || destroyed) return;

        playRequestId += 1;
        renderPlayback(false);

        setStatus(
          hasSource(media) ? labels.error_label || "Unable to play audio" : labels.missing_label || "Audio not configured"
        );
      });
    });

    const cleanup = () => {
      if (destroyed) return;

      destroyed = true;
      playRequestId += 1;

      removers.forEach((remove) => remove());
      pendingTimes.clear();

      stopFrame();
      els.raw.pause();
      els.clear.pause();

      if (sectionEl._es1lp4DemoCleanup === cleanup) {
        delete sectionEl._es1lp4DemoCleanup;
      }
    };

    // Section 被编辑器卸载时停止播放并清理事件。
    listen(document, "shopify:section:unload", (event) => {
      const eventSectionId = event.detail && event.detail.sectionId;

      if (String(eventSectionId || "") === shell.dataset.demoSectionId) {
        cleanup();
      }
    });

    sectionEl._es1lp4DemoCleanup = cleanup;

    setScene(sceneTabs[0].dataset.demoScene);

    return {
      section: sectionEl,
      setScene: setScene,
      setMode: setMode,
      destroy: cleanup
    };
  }

  initS1lp4Natural() {
    const sectionEl = this._q(".extend-s1lp4-natural");
    if (!sectionEl) return null;

    if (typeof sectionEl._es1lp4NaturalCleanup === "function") {
      sectionEl._es1lp4NaturalCleanup();
    }

    const q = (selector) => sectionEl.querySelector(selector);
    const qa = (selector) => Array.from(sectionEl.querySelectorAll(selector));

    const wrapper = q(".es1lp4nl__wrapper");
    if (!wrapper) return null;

    const approachButtons = qa(".es1lp4nl__approach-card[data-approach-config]");

    const intensityButtons = qa(".es1lp4nl__intensity-options [data-intensity-config]");

    if (!approachButtons.length && !intensityButtons.length) {
      return null;
    }

    const els = {
      tone: q("#metricTone"),
      detail: q("#metricDetail"),
      noise: q("#metricNoise"),
      toneLabel: q("#metricToneLabel"),
      detailLabel: q("#metricDetailLabel"),
      noiseLabel: q("#metricNoiseLabel"),
      context: q("#intensityContext"),
      description: q("#voicePanelDescription"),
      levelLabel: q("#levelLabel"),
      levelTitle: q("#levelTitle"),
      levelBody: q("#levelBody"),
      levelCopy: q(".es1lp4nl__level-copy"),
      noiseRing: q("#noiseRing"),
      voiceCore: q("#voiceCore")
    };

    const approaches = new Map();
    const intensities = new Map();
    const removers = [];

    let currentApproach = "";
    let currentIntensity = "";
    let destroyed = false;

    const parseConfig = (value) => {
      try {
        return JSON.parse(value || "{}");
      } catch (error) {
        console.warn("Invalid S1LP4 Natural configuration.", error);
        return {};
      }
    };

    approachButtons.forEach((button) => {
      approaches.set(button.dataset.approach, parseConfig(button.dataset.approachConfig));
    });

    intensityButtons.forEach((button) => {
      intensities.set(button.dataset.intensity, parseConfig(button.dataset.intensityConfig));
    });

    const listen = (element, eventName, handler) => {
      element.addEventListener(eventName, handler);

      removers.push(() => {
        element.removeEventListener(eventName, handler);
      });
    };

    const hasValue = (value) => {
      return value !== undefined && value !== null && String(value).trim() !== "";
    };

    const numberValue = (value, fallback, min, max) => {
      const parsed = hasValue(value) ? Number(value) : NaN;
      const number = Number.isFinite(parsed) ? parsed : fallback;

      return Math.min(max, Math.max(min, number));
    };

    const setText = (element, value) => {
      if (!element) return;

      const text = value == null ? "" : String(value);

      element.textContent = text;
      element.hidden = text.trim() === "";
    };

    const syncTabs = (buttons, dataKey, activeKey) => {
      buttons.forEach((button) => {
        const active = button.dataset[dataKey] === activeKey;

        button.classList.toggle("active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
        button.setAttribute("tabindex", active ? "0" : "-1");
      });
    };

    const renderResult = (data) => {
      if (!data) return;

      if (els.tone) {
        els.tone.style.setProperty("--value", numberValue(data.metric_tone, 0, 0, 100) + "%");
      }

      if (els.detail) {
        els.detail.style.setProperty("--value", numberValue(data.metric_detail, 0, 0, 100) + "%");
      }

      if (els.noise) {
        els.noise.style.setProperty("--value", numberValue(data.metric_noise, 0, 0, 100) + "%");
      }

      setText(els.toneLabel, data.metric_tone_label);
      setText(els.detailLabel, data.metric_detail_label);
      setText(els.noiseLabel, data.metric_noise_label);
      setText(els.context, data.context);
      setText(els.description, data.panel_description);
      setText(els.levelLabel, data.level_label);
      setText(els.levelTitle, data.level_title);
      setText(els.levelBody, data.level_body);

      if (els.levelCopy) {
        els.levelCopy.hidden = !(hasValue(data.level_label) || hasValue(data.level_title) || hasValue(data.level_body));
      }

      if (els.noiseRing) {
        const opacity = numberValue(data.noise_opacity, 52, 0, 100);

        const scale = numberValue(data.noise_scale, 96, 50, 150);

        els.noiseRing.style.opacity = String(opacity / 100);
        els.noiseRing.style.transform = "scale(" + scale / 100 + ")";
      }

      if (els.voiceCore) {
        const scale = numberValue(data.voice_scale, 100, 50, 150);

        const saturation = numberValue(data.voice_saturation, 75, 0, 300);

        const contrast = numberValue(data.voice_contrast, 100, 0, 300);

        els.voiceCore.style.transform = "scale(" + scale / 100 + ")";

        // 完整更新 filter，防止上一个方案的效果残留。
        els.voiceCore.style.filter = "saturate(" + saturation / 100 + ") " + "contrast(" + contrast / 100 + ")";
      }
    };

    const renderCurrent = () => {
      syncTabs(approachButtons, "approach", currentApproach);

      syncTabs(intensityButtons, "intensity", currentIntensity);

      let data;

      if (currentApproach === "vocalsense" && intensities.has(currentIntensity)) {
        data = intensities.get(currentIntensity);
      } else {
        data = approaches.get(currentApproach);
      }

      renderResult(data);
    };

    const setApproach = (key) => {
      if (destroyed || !approaches.has(key)) return;

      currentApproach = key;
      renderCurrent();
    };

    const setIntensity = (key) => {
      if (destroyed || !intensities.has(key)) return;

      currentIntensity = key;
      currentApproach = "vocalsense";
      renderCurrent();
    };

    const bindTabKeyboard = (buttons, selectButton) => {
      buttons.forEach((button, index) => {
        listen(button, "keydown", (event) => {
          let nextIndex = index;

          if (event.key === "ArrowRight" || event.key === "ArrowDown") {
            nextIndex = (index + 1) % buttons.length;
          } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
            nextIndex = (index - 1 + buttons.length) % buttons.length;
          } else if (event.key === "Home") {
            nextIndex = 0;
          } else if (event.key === "End") {
            nextIndex = buttons.length - 1;
          } else {
            return;
          }

          event.preventDefault();

          const nextButton = buttons[nextIndex];
          nextButton.focus();
          selectButton(nextButton);
        });
      });
    };

    approachButtons.forEach((button) => {
      listen(button, "click", () => {
        setApproach(button.dataset.approach);
      });
    });

    intensityButtons.forEach((button) => {
      listen(button, "click", () => {
        setIntensity(button.dataset.intensity);
      });
    });

    bindTabKeyboard(approachButtons, (button) => {
      setApproach(button.dataset.approach);
    });

    bindTabKeyboard(intensityButtons, (button) => {
      setIntensity(button.dataset.intensity);
    });

    currentIntensity = intensities.has(wrapper.dataset.defaultIntensity)
      ? wrapper.dataset.defaultIntensity
      : intensityButtons.length
        ? intensityButtons[0].dataset.intensity
        : "";

    currentApproach = approaches.has(wrapper.dataset.defaultApproach)
      ? wrapper.dataset.defaultApproach
      : approachButtons.length
        ? approachButtons[0].dataset.approach
        : "vocalsense";

    const cleanup = () => {
      if (destroyed) return;

      destroyed = true;
      removers.forEach((remove) => remove());

      if (sectionEl._es1lp4NaturalCleanup === cleanup) {
        delete sectionEl._es1lp4NaturalCleanup;
      }
    };

    listen(document, "shopify:section:unload", (event) => {
      const target = event.target;

      if (target && (target === sectionEl || (typeof target.contains === "function" && target.contains(sectionEl)))) {
        cleanup();
      }
    });

    sectionEl._es1lp4NaturalCleanup = cleanup;

    renderCurrent();

    return {
      section: sectionEl,
      setApproach: setApproach,
      setIntensity: setIntensity,
      destroy: cleanup
    };
  }
  initS1lp4Editing() {
    const sectionEl = this._q(".extend-s1lp4-editing");
    if (!sectionEl) return null;

    if (sectionEl._editingCleanup) {
      sectionEl._editingCleanup();
    }

    const q = (selector) => sectionEl.querySelector(selector);
    const qa = (selector) => Array.from(sectionEl.querySelectorAll(selector));

    const wrapper = q(".es1lp4ed__wrapper");
    const buttons = qa("[data-workflow-config]");
    const steps = qa("[data-workflow-step]");

    if (!wrapper || !buttons.length) return null;

    const fields = {
      kicker: q("#workflowKicker"),
      title: q("#workflowTitle"),
      body: q("#workflowBody"),
      noise: q("#payoffNoise"),
      repair: q("#payoffRepair"),
      publish: q("#payoffPublish"),
      note: q("[data-workflow-note]")
    };

    const configs = {};
    const listeners = [];

    buttons.forEach((button) => {
      try {
        configs[button.dataset.workflow] = JSON.parse(button.dataset.workflowConfig || "{}");
      } catch (error) {
        configs[button.dataset.workflow] = {};
      }
    });

    const setWorkflow = (key) => {
      const config = configs[key];
      if (!config) return;

      buttons.forEach((button) => {
        const active = button.dataset.workflow === key;
        button.classList.toggle("active", active);
        button.setAttribute("aria-selected", String(active));
      });

      Object.keys(fields).forEach((name) => {
        const element = fields[name];
        if (!element) return;

        const text = String(config[name] || "");
        element.textContent = text;
        element.hidden = !text.trim();
      });

      const visibleSteps = steps.filter((step) => step.dataset.workflowStep === key);
      const lastStep = visibleSteps[visibleSteps.length - 1];

      steps.forEach((step) => {
        const visible = step.dataset.workflowStep === key;

        step.hidden = !visible;
        step.style.display = visible ? "" : "none";
        step.classList.toggle("active", visible && (key === "s1" || step === lastStep));
        step.classList.remove("dim");
      });
    };

    buttons.forEach((button) => {
      const handler = () => setWorkflow(button.dataset.workflow);
      button.addEventListener("click", handler);
      listeners.push(() => button.removeEventListener("click", handler));
    });

    sectionEl._editingCleanup = () => {
      listeners.forEach((remove) => remove());
      delete sectionEl._editingCleanup;
    };

    setWorkflow(configs[wrapper.dataset.defaultWorkflow] ? wrapper.dataset.defaultWorkflow : buttons[0].dataset.workflow);

    return sectionEl;
  }

  initS1lp4Cases() {
    const sectionEl = this._q(".extend-s1lp4-cases");
    if (!sectionEl) return null;

    if (sectionEl._casesCleanup) sectionEl._casesCleanup();

    const q = (selector) => sectionEl.querySelector(selector);
    const qa = (selector) => Array.from(sectionEl.querySelectorAll(selector));

    const wrapper = q(".es1lp4cs__wrapper");
    const buttons = qa("[data-case-config]");
    const mediaItems = qa("[data-case-media]");
    const fallback = q("#caseFallback");
    const styles = ["street", "cafe", "car", "outdoor"];

    if (!wrapper || !buttons.length) return null;

    const fields = {
      type: q("#caseType"),
      kicker: q("#caseKicker"),
      title: q("#caseTitle"),
      body: q("#caseBody"),
      challenge: q("#caseChallenge"),
      listen: q("#caseListen")
    };

    const listeners = [];

    const pauseVideos = (media) => {
      media.querySelectorAll("video").forEach((video) => video.pause());
    };

    const setCase = (button) => {
      let config;

      try {
        config = JSON.parse(button.dataset.caseConfig || "{}");
      } catch (error) {
        return;
      }

      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle("active", active);
        item.setAttribute("aria-selected", String(active));
        item.setAttribute("tabindex", active ? "0" : "-1");
      });

      Object.keys(fields).forEach((name) => {
        const element = fields[name];
        if (!element) return;

        const text = String(config[name] || "");
        element.textContent = text;
        element.hidden = !text.trim();
      });

      ["challenge", "listen"].forEach((name) => {
        const element = fields[name];
        if (!element) return;

        const detail = element.closest(".es1lp4cs__detail");
        if (!detail) return;

        const label = detail.querySelector("small");
        detail.hidden = element.hidden && !(label && label.textContent.trim());
      });

      if (fallback) {
        fallback.classList.remove(...styles);
        fallback.classList.add(styles.includes(config.scene_style) ? config.scene_style : "street");
      }

      mediaItems.forEach((media) => {
        const active = media.dataset.caseMedia === button.dataset.case;
        if (!active) pauseVideos(media);

        media.hidden = !active;
        media.style.display = active ? "" : "none";
      });
    };

    buttons.forEach((button) => {
      const handler = () => setCase(button);
      button.addEventListener("click", handler);
      listeners.push(() => button.removeEventListener("click", handler));
    });

    sectionEl._casesCleanup = () => {
      listeners.forEach((remove) => remove());
      mediaItems.forEach(pauseVideos);
      delete sectionEl._casesCleanup;
    };

    setCase(buttons.find((button) => button.dataset.case === wrapper.dataset.defaultCase) || buttons[0]);

    return sectionEl;
  }
  initS1lp4Faq() {
    const sectionEl = this._q(".extend-s1lp4-faq");
    if (!sectionEl) return null;

    if (sectionEl._faqCleanup) sectionEl._faqCleanup();

    const items = Array.from(sectionEl.querySelectorAll(".es1lp4f__item"))
      .map((item) => ({
        item,
        button: item.querySelector(".es1lp4f__button"),
        panel: item.querySelector(".es1lp4f__panel")
      }))
      .filter(({ button, panel }) => button && panel);

    const removers = [];
    let resizeFrame = 0;

    const sync = ({ item, button, panel }) => {
      const open = item.classList.contains("open");

      button.setAttribute("aria-expanded", String(open));
      panel.setAttribute("aria-hidden", String(!open));
      panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
    };

    items.forEach((entry) => {
      const handler = () => {
        entry.item.classList.toggle("open");
        sync(entry);
      };

      entry.button.addEventListener("click", handler);
      removers.push(() => {
        entry.button.removeEventListener("click", handler);
      });

      sync(entry);
    });

    const onResize = () => {
      if (resizeFrame) return;

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;

        items.forEach((entry) => {
          if (entry.item.classList.contains("open")) sync(entry);
        });
      });
    };

    window.addEventListener("resize", onResize);

    sectionEl._faqCleanup = () => {
      removers.forEach((remove) => remove());
      window.removeEventListener("resize", onResize);
      cancelAnimationFrame(resizeFrame);
      delete sectionEl._faqCleanup;
    };

    return sectionEl;
  }
  initS1lp4Purchase() {
    const sectionEl = this._q(".extend-s1lp4-purchase");
    if (!sectionEl) return null;

    if (sectionEl._purchaseCleanup) sectionEl._purchaseCleanup();

    const q = (selector) => sectionEl.querySelector(selector);
    const qa = (selector) => Array.from(sectionEl.querySelectorAll(selector));

    const wrapper = q(".es1lp4pc__wrapper");
    const summary = q("#selectedPack");
    const included = q("[data-pack-included]");
    const button = q("#addToCart");
    const pdpLink = q("#pdpLink");

    const packs = qa("[data-pack-config]")
      .map((card) => {
        try {
          return {
            card,
            config: JSON.parse(card.dataset.packConfig || "{}")
          };
        } catch (error) {
          console.warn("Invalid purchase pack configuration.", error);
          return null;
        }
      })
      .filter(Boolean);

    const accordions = qa(".es1lp4pc__acc-item")
      .map((item) => ({
        item,
        button: item.querySelector(".es1lp4pc__acc-button"),
        panel: item.querySelector(".es1lp4pc__acc-panel")
      }))
      .filter((entry) => entry.button && entry.panel);

    const removers = [];
    let selected = null;
    let pending = false;
    let destroyed = false;
    let resizeFrame = 0;

    const errorElement = document.createElement("p");
    errorElement.hidden = true;
    errorElement.setAttribute("role", "alert");

    const checkoutRow = q(".es1lp4pc__checkout-row");
    if (checkoutRow) {
      checkoutRow.insertAdjacentElement("afterend", errorElement);
    }

    const listen = (element, event, handler) => {
      element.addEventListener(event, handler);
      removers.push(() => element.removeEventListener(event, handler));
    };

    const showError = (message = "") => {
      errorElement.textContent = message;
      errorElement.hidden = !message;
    };

    const syncAccordion = ({ item, button, panel }) => {
      const open = item.classList.contains("open");

      button.setAttribute("aria-expanded", String(open));
      panel.setAttribute("aria-hidden", String(!open));
      panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
    };

    const resizeOpenPanels = () => {
      accordions.forEach((entry) => {
        if (entry.item.classList.contains("open")) syncAccordion(entry);
      });
    };

    const syncButton = () => {
      if (!button) return;

      const configured = Boolean(selected && selected.variant_id);
      const available = configured && selected.available === true;

      button.dataset.variantId = configured ? String(selected.variant_id) : "";
      button.disabled = pending || !available;
      button.setAttribute("aria-busy", String(pending));

      button.textContent = !configured
        ? button.dataset.unconfiguredLabel || "Select a product and variant"
        : !available
          ? button.dataset.soldOutLabel || "Sold out"
          : button.dataset.buttonLabel || "Add to cart";
    };

    const setPack = ({ card, config }) => {
      selected = config;
      showError();

      packs.forEach((pack) => {
        const active = pack.card === card;

        pack.card.classList.toggle("active", active);
        pack.card.setAttribute("aria-checked", String(active));
        pack.card.setAttribute("tabindex", active ? "0" : "-1");
      });

      if (summary) {
        summary.textContent = [config.title, config.price_label].filter(Boolean).join(" — ");
      }

      if (included) {
        // 来自对应 Pack Block 的富文本配置。
        included.innerHTML = config.included || "";
      }

      if (pdpLink) {
        pdpLink.hidden = !config.url || !pdpLink.textContent.trim();

        if (config.url) {
          pdpLink.href = config.url;
        } else {
          pdpLink.removeAttribute("href");
        }
      }

      syncButton();
      resizeOpenPanels();

      // 更新悬浮框中的值
      this.initStickyBarDefault();
    };

    packs.forEach((pack) => {
      listen(pack.card, "click", () => setPack(pack));
    });

    accordions.forEach((entry) => {
      listen(entry.button, "click", () => {
        entry.item.classList.toggle("open");
        syncAccordion(entry);
      });

      syncAccordion(entry);
    });

    if (button) {
      listen(button, "click", async () => {
        if (pending || !selected || !selected.variant_id || selected.available !== true) {
          return;
        }

        const addUrl = button.dataset.cartAddUrl;
        const cartUrl = button.dataset.cartUrl;

        if (!addUrl || !cartUrl) {
          showError("Cart URLs are not configured.");
          return;
        }

        const variantId = String(selected.variant_id);

        pending = true;
        showError();
        syncButton();

        try {
          const response = await fetch(addUrl.replace(/\.js$/, "") + ".js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }]
            })
          });

          const result = await response.json();

          if (!response.ok || result.status >= 400) {
            throw new Error(result.description || result.message || "Unable to add this item to your cart.");
          }

          if (!destroyed) window.location.assign(cartUrl);
        } catch (error) {
          if (!destroyed) {
            showError(error.message || "Unable to add this item to your cart.");
          }
        } finally {
          pending = false;
          if (!destroyed) syncButton();
        }
      });
    }

    listen(window, "resize", () => {
      if (resizeFrame) return;

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        resizeOpenPanels();
      });
    });

    sectionEl._purchaseCleanup = () => {
      destroyed = true;
      removers.forEach((remove) => remove());
      cancelAnimationFrame(resizeFrame);
      errorElement.remove();
      delete sectionEl._purchaseCleanup;
    };

    const initialPack =
      packs.find((pack) => {
        return wrapper && pack.card.dataset.pack === wrapper.dataset.defaultPack;
      }) || packs[0];

    if (initialPack) {
      setPack(initialPack);
    } else {
      syncButton();
    }

    return sectionEl;
  }

  initS1LP4TitleHero() {
    const heroEl = this._q(".extend-s1lp4-hero-title");
    if (!heroEl) return;
    const _initProductCards = () => {
      const dots = this._qa("[name='product-dot']", heroEl);
      const cards = this._qa("[name='product-card']", heroEl);
      if (!dots.length) return;
      dots[0].classList.add("active");
      cards[0].classList.add("active");
      dots.forEach((dotEl, index) => {
        dotEl.addEventListener("click", () => {
          if (dotEl.classList.contains("active")) return;
          dots.forEach((el, elIndex) => {
            el.classList.remove("active");
            cards[elIndex].classList.remove("active");
          });
          dotEl.classList.add("active");
          cards[index].classList.add("active");
        });
      });
    };
    const _initProductStage = () => {
      const parallax = this._q("[data-parallax]", heroEl);
      if (matchMedia("(pointer:fine)").matches) {
        parallax.addEventListener("pointermove", (e) => {
          const r = parallax.getBoundingClientRect(),
            x = (e.clientX - r.left) / r.width - 0.5,
            y = (e.clientY - r.top) / r.height - 0.5;
          this._q(".es1lp4thr__product-stage", parallax).style.transform = `rotateY(${x * 6 - 3}deg) rotateX(${y * -4}deg)`;
        });
        parallax.addEventListener(
          "pointerleave",
          () => (this._q(".es1lp4thr__product-stage", parallax).style.transform = "rotateY(-3deg)")
        );
      }
    };

    _initProductCards();
    _initProductStage();
  }

  initS1lp4CompareTitle() {
    const sectionEl = this._q(".extend-s1lp4-compare-title");
    if (!sectionEl) return null;

    if (sectionEl._compareTitleCleanup) {
      sectionEl._compareTitleCleanup();
    }

    const q = (selector) => sectionEl.querySelector(selector);
    const qa = (selector) => Array.from(sectionEl.querySelectorAll(selector));

    const wrapper = q(".es1lp4tcp__wrapper");
    const buttons = qa("[data-take-config]");
    const mediaItems = qa("[data-take-media]");
    const container = q("#comparison-video");
    const panel = q("#comparison-panel");
    const preview = q("#demo-label");

    if (!wrapper || !buttons.length || !container) return null;

    const fields = {
      title: q("#take-title"),
      subtitle: q("#take-subtitle"),
      description: q("#take-description")
    };

    const listeners = [];
    const configs = new Map();

    buttons.forEach((button) => {
      try {
        configs.set(button, JSON.parse(button.dataset.takeConfig || "{}"));
      } catch (error) {
        console.warn("Invalid comparison configuration.", error);
      }
    });

    const pauseVideos = (media) => {
      media.querySelectorAll("video").forEach((video) => video.pause());
    };

    const setTake = (button) => {
      const config = configs.get(button);
      if (!config) return;

      buttons.forEach((item) => {
        item.setAttribute("aria-selected", String(item === button));
        item.setAttribute("tabindex", "0");
      });

      if (panel) panel.setAttribute("aria-labelledby", button.id);

      Object.keys(fields).forEach((name) => {
        const element = fields[name];
        if (!element) return;

        element.textContent = config[name] || "";
        element.hidden = !element.textContent.trim();
      });

      let hasVideo = false;

      mediaItems.forEach((media) => {
        const active = media.dataset.takeMedia === button.dataset.take;

        if (!active) pauseVideos(media);

        media.hidden = !active;
        media.style.display = active ? "" : "none";

        if (active) hasVideo = media.dataset.hasVideo === "true";
      });

      container.hidden = !hasVideo;
      container.style.display = hasVideo ? "" : "none";

      if (preview) {
        const show = !hasVideo && Boolean(preview.textContent.trim());
        preview.hidden = !show;
        preview.style.display = show ? "" : "none";
      }
    };

    buttons.forEach((button) => {
      const handler = () => setTake(button);
      button.addEventListener("click", handler);
      listeners.push(() => button.removeEventListener("click", handler));
    });

    sectionEl._compareTitleCleanup = () => {
      listeners.forEach((remove) => remove());
      mediaItems.forEach(pauseVideos);
      delete sectionEl._compareTitleCleanup;
    };

    setTake(
      buttons.find((button) => configs.has(button) && button.dataset.take === wrapper.dataset.defaultTake) ||
        buttons.find((button) => configs.has(button))
    );

    return sectionEl;
  }

  initS1lp4TechTitle() {
    const sectionEl = this._q(".extend-s1lp4-tech-title");
    if (!sectionEl) return null;

    if (sectionEl._techTitleCleanup) {
      sectionEl._techTitleCleanup();
    }

    const q = (selector) => sectionEl.querySelector(selector);

    const wrapper = q(".es1lp4tht__wrapper");
    const modeSwitch = q("#mode-switch");
    const modeCopy = q("#mode-copy");
    const slider = q("#es1lp4tht__noise-level");
    const noiseCopy = q("#noise-copy");

    if (!wrapper || !modeSwitch || !slider) return null;

    const config = wrapper.dataset;

    const lowThreshold = Number(config.noiseLowThreshold || 30);
    const highThreshold = Number(config.noiseHighThreshold || 70);

    const updateMode = () => {
      const enabled = modeSwitch.getAttribute("aria-checked") === "true";

      slider.disabled = !enabled;

      if (modeCopy) {
        modeCopy.textContent = enabled ? config.modeOn || "" : config.modeOff || "";
      }
    };

    const updateNoise = () => {
      const value = Number(slider.value);
      const min = Number(slider.min || 0);
      const max = Number(slider.max || 100);

      const percent = max > min ? ((value - min) / (max - min)) * 100 : 0;

      slider.style.setProperty("--range-progress", `${Math.min(100, Math.max(0, percent))}%`);

      if (noiseCopy) {
        noiseCopy.textContent =
          value < lowThreshold
            ? config.noiseLow || ""
            : value >= highThreshold
              ? config.noiseHigh || ""
              : config.noiseBalanced || "";
      }
    };

    const toggleMode = () => {
      const enabled = modeSwitch.getAttribute("aria-checked") === "true";

      modeSwitch.setAttribute("aria-checked", String(!enabled));
      updateMode();
    };

    modeSwitch.addEventListener("click", toggleMode);
    slider.addEventListener("input", updateNoise);

    sectionEl._techTitleCleanup = () => {
      modeSwitch.removeEventListener("click", toggleMode);
      slider.removeEventListener("input", updateNoise);
      delete sectionEl._techTitleCleanup;
    };

    updateMode();
    updateNoise();

    return sectionEl;
  }
  initS1lp4CreatorsTitle() {
    const sectionEl = this._q(".extend-s1lp4-creators-title");
    if (!sectionEl) return null;

    if (sectionEl._creatorsTitleCleanup) {
      sectionEl._creatorsTitleCleanup();
    }

    const wrapper = sectionEl.querySelector(".es1lp4ct__wrapper");
    const filters = Array.from(sectionEl.querySelectorAll("[data-filter]"));
    const cards = Array.from(sectionEl.querySelectorAll(".es1lp4ct__card"));
    const removers = [];

    if (!wrapper) return null;

    const pauseVideos = (container) => {
      container.querySelectorAll("video").forEach((video) => {
        video.pause();
      });
    };

    const setFilter = (key) => {
      filters.forEach((button) => {
        button.setAttribute("aria-pressed", String(button.dataset.filter === key));
      });

      cards.forEach((card) => {
        const hidden = key !== "all" && card.dataset.category !== key;

        if (hidden) pauseVideos(card);
        card.hidden = hidden;
      });
    };

    filters.forEach((button) => {
      const handler = () => setFilter(button.dataset.filter);

      button.addEventListener("click", handler);
      removers.push(() => {
        button.removeEventListener("click", handler);
      });
    });

    const onVisibilityChange = () => {
      if (document.hidden) pauseVideos(sectionEl);
    };

    document.addEventListener("visibilitychange", onVisibilityChange);

    sectionEl._creatorsTitleCleanup = () => {
      removers.forEach((remove) => remove());
      document.removeEventListener("visibilitychange", onVisibilityChange);

      pauseVideos(sectionEl);
      delete sectionEl._creatorsTitleCleanup;
    };

    const initialFilter = filters.find((button) => {
      return button.dataset.filter === wrapper.dataset.defaultFilter;
    });

    setFilter(initialFilter ? initialFilter.dataset.filter : "all");

    return sectionEl;
  }
}
